document.addEventListener("DOMContentLoaded", async () => {
    const outputApi = document.querySelector("#test-dmag-api");
    if (outputApi) {
        await fetchData();
    }
});

async function fetchData() {
    return new Promise((resolve, reject) => {
        fetch('https://api.cityspark.com/v2/event/search', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-API-Key': 'YOUR_SECRET_TOKEN'
            },
            body: JSON.stringify({
                portalScriptId: 'CitySparkPortalHome',
                searchTerm: null,
                latitude: null,
                longitude: null,
                radius: null,
                categories: null,
                interest: null,
                labels: null,
                blockVirtual: null,
                includeLabels: false,
                includeInstances: false,
                handPicked: null,
                pageSize: null,
                page: 1,
                lastUpdatedDate: null,
                startDate: null,
                endDate: null,
                sortBy: 'DayPopularity',
                descriptionFormat: 'PlainText',
                polygonPoints: null
            })
        })
        .then((a) => {
            resolve(a);
        });
    });
}